<div class="inventory-health-chip-wrapper" *ngIf="REPRICING_INVENTORY_STATUS_STATE_DISPLAY[state] as stateDisplay">
    <div
        class="inventory-health-chip"
        [ngClass]="[stateDisplay.chipStyleClass, 'inventory-health-chip--' + size]"
        [class.inventory-health-chip--active]="active"
        (click)="onClick($event)"
    >
        <span class="inventory-health-chip-icon" [innerHTML]="sanitizer.bypassSecurityTrustHtml(stateDisplay.icon)"></span>
        <span class="inventory-health-chip-title">{{stateDisplay.title}}</span>
        <span class="inventory-health-chip-sublabel" *ngIf="sublabel">{{ sublabel }}</span>
        <span class="chip-count" *ngIf="count !== undefined">{{ count }}</span>
    </div>
</div>
